import { createFileRoute } from "@tanstack/react-router"
import { DocumentMMRPage } from "../../../../../components/WMS/Transfers/MMR/DocumentMMRPage"

export const Route = createFileRoute("/_layout/WMS/documents/doc-mmr/$docMmr")({
  component: DocumentMMRPage,
})
